import makeStyles from '@mui/styles/makeStyles';

export default makeStyles((theme) => ({
    cropperContainer: {
        position: 'relative',
        paddingBottom: '80%',
        width: '100%'
    },
    [`${theme.breakpoints.down('xl')} and (orientation: landscape)`]: {
        // eslint-disable-line no-useless-computed-key
        cropperContainer: {
            paddingBottom: '50vh'
        }
    },
    cropperImage: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0
    },
    cropper: {
        width: '100%',
        height: '100%'
    },
    textContainer: {
        marginTop: 10,

        width: '90%',
        [theme.breakpoints.up('sm')]: {
            marginTop: 30
        }
    },
    cropperButtons: {
        textAlign: 'center',
        padding: '10px 0',
        width: '90%',
        fontWeight: 600,
        textTransform: 'none',
        [theme.breakpoints.up('sm')]: {
            padding: '20px 0'
        }
    }
}));
